const formTranslation = {
  'form.search': 'Buscar',
  'form.name': 'Nome',
  'form.email': 'E-mail',
  'form.confirmEmail': 'Confirme seu E-mail',
  'form.language': 'Idioma',
  'form.language.en-US': 'Inglês (US)',
  'form.language.pt-BR': 'Português (BR)',
  'form.password': 'Senha',
  'form.confirmPassword': 'Confirme sua Senha',
  'form.type.natural': 'Pessoa Física',
  'form.type.legal': 'Pessoa Jurídica',
  'form.businessName': 'Nome Empresarial',
  'form.gender': 'Gênero',
  'form.gender.male': 'Masculino',
  'form.gender.female': 'Feminino',
  'form.gender.other': 'Outro',
  'form.birthdate': 'Data de Nascimento',
  'form.photo': 'Foto',
  'form.phone': 'Contato',
  'form.businessPhone': 'Contato Comercial',
  'form.country': 'País',
  'form.state': 'Estado',
  'form.city': 'Cidade',
  'form.zipcode': 'CEP',
  'form.street': 'Endereço',
  'form.login.subtitle': 'Acesse sua conta',
  'form.login.button': 'Entrar',
  'form.register.button': 'Cadastrar',
  'form.submit.button': 'Enviar',
  'form.save.button': 'Salvar',
  'form.cancel.button': 'Cancelar',
  'form.seeAll.button': 'Ver Todos',
  'form.next.button': 'Próximo',
  'form.prev.button': 'Anterior',
  'form.goback.button': 'Voltar',
  'form.select.placeholder': 'Selecione...',
};

export default formTranslation;
